"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./styles");

var _designLanguage = require("@doordash/design-language");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _componentSeparator = _interopRequireDefault(require("@doordash/component-separator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GridSeparator = function GridSeparator(_ref) {
  var isSquished = _ref.isSquished,
      insetHorizontalSize = _ref.insetHorizontalSize,
      insetVerticalSize = _ref.insetVerticalSize,
      type = _ref.type,
      middleColumn = _ref.middleColumn,
      shouldInsetStartAtTitle = _ref.shouldInsetStartAtTitle;
  var gridColumnStart = type === _componentSeparator["default"].Types.InsetBorder && shouldInsetStartAtTitle ? middleColumn : 1;
  return /*#__PURE__*/_react["default"].createElement(_styles.GridSeparatorContainer, {
    gridColumnStart: gridColumnStart,
    type: type,
    isSquished: isSquished,
    insetHorizontalSize: insetHorizontalSize,
    insetVerticalSize: insetVerticalSize
  }, /*#__PURE__*/_react["default"].createElement(_componentSeparator["default"], {
    type: type === _componentSeparator["default"].Types.InsetBorder ? _componentSeparator["default"].Types.FullBorder : type
  }));
};

GridSeparator.propTypes = {
  isSquished: _propTypes["default"].bool.isRequired,
  insetHorizontalSize: _propTypes["default"].oneOf(Object.values(_designLanguage.Inset.Sizes)).isRequired,
  insetVerticalSize: _propTypes["default"].oneOf(Object.values(_designLanguage.Inset.Sizes)).isRequired,
  type: _componentSeparator["default"].propTypes.type,
  middleColumn: _propTypes["default"].number.isRequired,
  shouldInsetStartAtTitle: _propTypes["default"].bool.isRequired
};
var _default = GridSeparator;
exports["default"] = _default;